import { render } from "./EntryView.vue?vue&type=template&id=4c708e1d&lang=pug"
import script from "./EntryView.vue?vue&type=script&lang=js"
export * from "./EntryView.vue?vue&type=script&lang=js"

import "./EntryView.vue?vue&type=style&index=0&id=4c708e1d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__